import { render, staticRenderFns } from "./CustomerSummary.vue?vue&type=template&id=226c866b&scoped=true"
import script from "./CustomerSummary.vue?vue&type=script&lang=js"
export * from "./CustomerSummary.vue?vue&type=script&lang=js"
import style0 from "./CustomerSummary.vue?vue&type=style&index=0&id=226c866b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226c866b",
  null
  
)

export default component.exports